/**
 * Hand-rolled SVG sparkline. Stupidly small, no charting library.
 * Accepts a numeric series; renders a smooth area + line. Auto-scales.
 */
export function Sparkline({
  data,
  width = 120,
  height = 32,
  color = "#0F766E",
  fillOpacity = 0.12,
  strokeWidth = 1.75,
}: {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
  fillOpacity?: number;
  strokeWidth?: number;
}) {
  if (data.length < 2) {
    return (
      <svg width={width} height={height} className="overflow-visible">
        <line
          x1={0}
          y1={height / 2}
          x2={width}
          y2={height / 2}
          stroke="#E2E8F0"
          strokeDasharray="2 3"
          strokeWidth={1}
        />
      </svg>
    );
  }
  const min = Math.min(...data);
  const max = Math.max(...data);
  const span = max - min || 1;
  const pad = 2;
  const innerW = width - pad * 2;
  const innerH = height - pad * 2;
  const step = innerW / (data.length - 1);
  const points = data.map((v, i) => {
    const x = pad + i * step;
    const y = pad + innerH - ((v - min) / span) * innerH;
    return [x, y] as const;
  });
  const path = points.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`).join(" ");
  const areaPath = `${path} L${points[points.length - 1]?.[0].toFixed(2)},${(height - pad).toFixed(2)} L${pad},${(height - pad).toFixed(2)} Z`;
  return (
    <svg width={width} height={height} className="block overflow-visible">
      <path d={areaPath} fill={color} fillOpacity={fillOpacity} />
      <path d={path} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
